<template>
    <div class="card-info-item-container" :key="data ? data.id : null">
        <div class="card-info" :style="cardInfoItemStyling">
            <InputField v-if="editingData" :key="data" :input-type="'select'" :value="data.id" :label="editableLabel"
                :select-options-list="editableInputOptions" :input-disabled="editingData && specialDisable" :size="'large'"
                :inputFieldContainerStyling="{ 'padding': '0' }" @input="updateField($event)" />
            <div class="card-info-container" :style="editingData ? 'margin-top: 20px' : ''">
                <div v-if="!editingData" class="card-info-item">
                    <v-icon class="card-icon">apartment</v-icon>
                    <span class="card-info-item-label">{{ $tc('Company', 1) }}:&nbsp;</span>
                    <span v-if="data" class="card-info-item-value">{{ data.name }} </span>
                </div>
                <div class="card-info-item">
                    <v-icon class="card-icon">location_on</v-icon>
                    <span class="card-info-item-label">{{ $tc('Address', 1) }}:&nbsp;</span>
                    <span v-if="data" class="card-info-item-value">{{ data.address }} </span>
                </div>
                <div class="card-info-item">
                    <v-icon class="card-icon">mail</v-icon>
                    <span class="card-info-item-label">{{ $tc('E-mail', 1) }}:&nbsp;</span>
                    <span v-if="data" class="card-info-item-value">{{ data.email }} </span>
                </div>
                <div class="card-info-item">
                    <v-icon class="card-icon">call</v-icon>
                    <span class="card-info-item-label">{{ $tc('Phone', 1) }}:&nbsp;</span>
                    <span v-if="data" class="card-info-item-value">{{ data.phone }} </span>
                </div>
                <div class="card-info-item">
                    <v-icon class="card-icon">label</v-icon>
                    <span class="card-info-item-label">{{ $tc('Level', 1) }}:&nbsp;</span>
                    <span v-if="data" class="card-info-item-value">{{ companyLevelLabel }} </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CustomButton from '../_Atoms/CustomButton'
import InputField from "@/newComponents/_Atoms/InputField.vue";
import { mapActions } from 'vuex';
import _ from 'lodash';
import { bus } from "@/main.js";

export default {
    name: "SingleEditObjectMainInfoCompanies",

    components: {
        CustomButton,
        InputField,
    },

    props: {
        fields: {
            type: Array,
            default: [{

            }]
        },

        editableInputOptions: {
            type: Array,
        },

        editableLabel: {
            type: String,
        },

        editingData: {
            type: Boolean,
        },

        data: {
            type: Object,
            required: true,
        },

        specialDisable: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            buttonStyling: {
                'padding': '0px',
                'drop-shadow': '0.85px 0.85px 1.75px rgba(0, 0, 0, 0.25)',
                'border-radius': '4px'
            },
            actionButtonsStyling: {
                'border': '1px solid #29BDF0',
                'border-radius': '7px',
                'font-size': '10px',
                'line-height': '12px',
                'height': '20px',
                'font-weight': '600'
            },
            actionButtonsStylingSave: {
                'font-size': '10px',
                'line-height': '12px',
                'height': '20px',
                'font-weight': '600'
            },
            companyLevelLabel: "",
        }
    },

    computed: {
        cardInfoItemStyling() {
            return {
                'width': this.editingData ? '100%' : 'auto',
                'margin': !this.editingData ? '10px 12px 10px 0' : ' 6px 9px 6px 0'
            }
        },

        cardHeight() {
            return 'calc(' + this.height + ' - 8px)';
        }
    },

    mounted() {
        // this.updateField(this.data);
        this.getLevelList()
    },

    methods: {
        ...mapActions([
            "GET_LIST",
        ]),

        fieldIsBarcodeField(label) {
            return label === this.$i18n.t('Barcode')
        },

        async getLevelList() {
            this.loading = true;
            try {
                const result = await this.GET_LIST({
                    listName: 'list_company_level'
                });

                const matchingLevel = result.find(item => item.code === this.data.company_level_id);
                if (matchingLevel) {
                    if (matchingLevel.client_label) {
                        this.companyLevelLabel = matchingLevel.client_label;
                    } else {
                        this.companyLevelLabel = matchingLevel.libelle;
                    }
                } else {
                    this.companyLevelLabel = null;
                }
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },

        updateField: _.debounce(function (event) {
            let parsedValue = event;
            const company = this.editableInputOptions.find(element => element.id === parsedValue);
            if(company){
                this.$emit('update-company', company);
                bus.$emit("update-company-bus", company);
            }else{
                this.$emit('update-company', {});
                bus.$emit("update-company-bus", {});
                this.companyLevelLabel = "";
            }
            
            if(parsedValue){
                bus.$emit("copyFromEnable", false);
            }else{
                bus.$emit("copyFromEnable", true);
            }
        }, 500),
    },
}
</script>

<style scoped>
.object-info-card {
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
    border-radius: 8px;
    padding: 17px 21px;
    overflow-y: hidden;
}

.card-info-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 3;
}

.card-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 5px;
}

.title-label {
    color: #29BDF0;
    font-family: Lato;
    font-size: 10px;
    font-style: normal;
    font-weight: 700;
    line-height: 11.5px;
    text-transform: uppercase;
}

.title-reference {
    color: #767676;
    font-family: Lato;
    font-size: 10px;
    font-style: normal;
    font-weight: 800;
    line-height: 11.5px;
    text-transform: uppercase;
}

.card-info-item-container {
    display: flex;
    flex-direction: row;
    gap: 13px;
    margin-top: 20px;
}

.card-info-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 20px;
}

.card-info-item-value,
.card-info-item-label {
    color: #767676;
    font-family: Lato;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 11.5px;
    white-space: nowrap;
}

.card-info-item-value {
    font-weight: 800;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.card-info {
    width: 100% !important;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    max-height: 87%;
}

.card-icon {
    margin-right: 8px;
}

.v-icon {
    line-height: 0;
    color: #29BDF0;
    font-size: 15px;
}

::-webkit-scrollbar {
    width: 4px;
}

.buttons-container {
    display: flex;
    flex-direction: row;
    gap: 6px
}

.action-buttons {
    display: flex;
    flex-direction: row;
    gap: 10px;
    justify-content: flex-end;
    position: absolute;
    right: 21px;
    bottom: 17px;
}
</style>


// WEBPACK FOOTER //
// src/newComponents/_Organisms/SingleEditObjectMainInfoCompanies.vue